module.exports = __webpack_public_path__ + "media/flags/cm-8ba1901d.svg";